import { render } from "./clickDrag.vue?vue&type=template&id=7bbc43ae&scoped=true"
import script from "./clickDrag.vue?vue&type=script&lang=js"
export * from "./clickDrag.vue?vue&type=script&lang=js"

import "./clickDrag.vue?vue&type=style&index=0&id=7bbc43ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bbc43ae"]])

export default __exports__